import styled, { css } from 'styled-components';
const SquareAvatar = css `
  border-radius: ${({ theme }) => `${theme.border_radius.none}`};
`;
const RoundedCornerAvatar = css `
  border-radius: ${({ theme }) => `${theme.border_radius.sm}`};
`;
const RoundAvatar = css `
  border-radius: ${({ theme }) => `${theme.border_radius.full}`};
`;
export const AvatarContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  background: ${({ $background }) => $background};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  color: ${(props) => props.theme.colors.white_1};
  font-weight: ${(props) => props.theme.fontWeights.regular};
  font-size: ${({ $size }) => $size * 0.66}px;
  line-height: ${({ $size }) => $size}px;
  overflow: hidden;
  text-transform: capitalize;
  flex-shrink: 0;
  flex-grow: 0;
  position: relative;

  ${({ $shape }) => $shape === 'round'
    ? RoundAvatar
    : $shape === 'rounded-corner'
        ? RoundedCornerAvatar
        : SquareAvatar}
`;
export const StyledAvatar = styled.img `
  object-fit: cover;
  object-position: center;
  transition: opacity linear 100ms;
`;
